import React from "react";
import { useSector } from "./SectorContext";

function AwardSection() {
  const { awardData, activeSector } = useSector();
  return (
    <section className="award-section">
      <div className="award-wrapper">
        {awardData.map((award) => (
          <div className="award-card" key={`${award.awardname}-${award.year}`}>
            <a
              href={award.certlink}
              className="award-image-link"
              target="_blank"
              aria-label={`View and verify ${award.awardname}`}
            >
              {" "}
              <img
                className="award-image"
                src={award.badgeimage}
                alt={award.awardname}
              />
              {/* <div className="award-title">{award.awardname}</div>
              <div className="award-category">{award.category}</div>
              <div className="award-name">client: {award.client} </div>
              <div className="award-name">campaign: {award.campaign}</div>
              <div className="award-year">year: {award.year}</div>
              <div className="award-name">Role: {award.role}</div>

               */}
              <div className="award-title">{award.awardname}</div>
              <div className="award-category">{award.category}</div>
              <div className="award-meta">
                <div>
                  <strong>Client</strong> {award.client}
                </div>

                <div>
                  <strong>Campaign</strong> {award.campaign}
                </div>

                <div>
                  <strong>Year</strong> {award.year}
                </div>

                <div>
                  <strong>Role</strong> {award.role}
                </div>
              </div>
            </a>
          </div>
        ))}
      </div>
    </section>
  );
}

export default AwardSection;
